import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TuiButton } from '@taiga-ui/core';
import { TuiTextfieldControllerModule, TuiInputModule } from '@taiga-ui/legacy';
import { TranslateModule } from '@ngx-translate/core';
import { ComponentsModule } from '@src/app/components';

import { DeleteAuthUserLinkComponent } from './delete-auth-user-link.component';
import { DeleteAuthUserDialogComponent } from './components';

@NgModule({
  declarations: [DeleteAuthUserLinkComponent, DeleteAuthUserDialogComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ComponentsModule,
    TranslateModule,
    TuiInputModule,
    TuiTextfieldControllerModule,
    TuiButton,
  ],
  exports: [DeleteAuthUserLinkComponent],
})
export class DeleteAuthUserLinkModule {}
